export default [{
    path: '/node/industryNode',
    name: 'industryNode',
    meta: {
        index: 15
    },
    component: () => import('@/views/node/industryNode.vue')
}]
